import { render, staticRenderFns } from "./DatepickerDateMonthViewOnly.vue?vue&type=template&id=36e835fe&"
import script from "./DatepickerDateMonthViewOnly.vue?vue&type=script&lang=js&"
export * from "./DatepickerDateMonthViewOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports